import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, NgModule } from '@angular/core';
import { Cms } from '@impact/data';

import { RichTextModule } from '../../rich-text/rich-text.module';
import { UtilsModule } from '../../utils/utils.module';

@Component({
    selector: 'app-disclaimer-spot',
    template: `
        <section class="disclaimer-spot" *ngIf="data">
            <app-rich-text *ngIf="data?.text" [html]="data?.text"></app-rich-text>
            <img
                *ngIf="data?.image"
                [src]="data?.image?.src | resolveMediaUrl: { format: 'webp'}"
                [alt]="data?.image?.alt"
                loading="lazy"
            />
        </section>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})
class DisclaimerSpotComponent {
    static ref = 'disclaimerspot';

    @Input() data: Cms.DisclaimerSpot;

}

@NgModule({
    declarations: [DisclaimerSpotComponent],
    imports: [
        CommonModule,
        RichTextModule,
        UtilsModule
    ]
})
class DisclaimerSpotModule {}

export const LazySpotComponent = DisclaimerSpotComponent;
